import './MenuBottom.css';

import React, { Component } from 'react';

import { Link } from "react-router-dom";

export class MenuBottomGeo extends Component {
    static displayName = MenuBottomGeo.name;
    state = {
        progress: false,
        isNavCollapsed: false,
    };

    componentDidMount() {

    }
 

    render() {
        return (
            <>
                <div id="footerCar" className="col-xl-4 col-md-4 col-sm-8 ">
                    <div id="groupMenuBottom " className="p-2"  style={{height:"40px"}}>
                        <span id="captionMenuBottom">
                        </span>
                    </div>
                    <div className="d-flex flex-row    " id="flexRow" >
                        <div className="flex-fill d-flex   justify-content-center">
                        <Link to="/main">
                        <img
                            src="/images/ic_home_n.png"
                            id="imgLogoBottom"
                            className=" justify-content-center"
                        />
                    </Link>
                        </div>
                    </div>
                </div>
            </>
        );
    }
 
   



}